import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "../utility/apiFetch.js";

export function useDashboardQuery() {
  return useQuery({
    queryKey: ["dashboard"],
    queryFn: () => apiFetch("dashboard"),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
